import { motion } from 'framer-motion';

const WorkCard = ({ item, index, onClick }) => {
  return (
    <motion.div
      data-testid={`work-card-${item.id}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="work-card cursor-pointer group"
      onClick={() => onClick(item)}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-muted">
        {/* Image */}
        {item.image ? (
          <img 
            src={item.image} 
            alt={item.title}
            className="absolute inset-0 w-full h-full object-cover work-card-image"
            loading="lazy"
          />
        ) : (
          <div className="absolute inset-0 grid-pattern work-card-image" />
        )}
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-foreground/0 group-hover:bg-foreground/90 transition-colors duration-500 flex items-center justify-center">
          <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500 text-center px-4">
            <span className="text-white text-sm uppercase tracking-widest">
              View Project
            </span>
          </div>
        </div>

        {/* Category pill */}
        <div className="absolute top-4 left-4">
          <span className="pill-tag text-[10px]">{item.category}</span>
        </div>
      </div>

      <div className="py-4">
        <h3 className="text-lg md:text-xl font-medium tracking-tight font-['DM_Sans']">
          {item.title}
        </h3>
      </div>
    </motion.div>
  );
};

export default WorkCard;
